export const START_FETCH = 'app/START_FETCH'
export const FINISH_FETCH = 'app/FINISH_FETCH'
export const ADD_FETCH = 'app/ADD_FETCH'
export const DELETE_FETCH = 'app/DELETE_FETCH'
